import styled from '@emotion/styled'
import Title from '@organisms/Title'

export const StyledTitle = styled(Title)`
  margin-bottom: 15px;
`
